import React from 'react'
import PropTypes from 'prop-types'
import { PromptBar, Popup } from 'components/UIElements'
import useInstrumentUnificationFeature from 'utils/hooks/useInstrumentUnificationFeature'

const LocalTimePrompt = ({ disabled = false, study, userId, isDiary }) => {
  const { hasInstrumentUnification } = useInstrumentUnificationFeature({ study, userId })

  const isShown = hasInstrumentUnification ? true : !isDiary

  return isShown ? (
    <PromptBar className={`flexed${disabled ? ' disabled' : ''}`} status='medium'>
      <p>Note: All of the schedule times will adhere to each participant&apos;s local time zones.</p>
      <Popup hover noPointer dark position='bottom' trigger={<i className='fas fa-info-circle' />}>
        <p>
          <span>
            In the particular case in which a participant is in a different time zone from the time the instrument is
            scheduled, they will receive the instrument according to the time zone they were in
          </span>
          <strong> when this instrument was scheduled</strong>
          <span>.</span>
        </p>
      </Popup>
    </PromptBar>
  ) : null
}

LocalTimePrompt.propTypes = {
  disabled: PropTypes.bool,
}

export default LocalTimePrompt
